import { validator } from "@/utils/validator";

export const companySupporterSchema = validator.object().shape({
  supporterTelNumber: validator.string().trim().emptyToNull().label("電話番号").notRequired(),
});
